import { Directive, inject, input } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: '[libBackButton]',
  // Back buttons are icon-only, so they get an accessible name unless the host sets its own aria-label
  host: {
    '[attr.aria-label]': 'ariaLabel()',
    '(click)': 'onClick()',
  },
})
export class BackButtonDirective {
  readonly ariaLabel = input('Back', { alias: 'aria-label' });

  #location = inject(Location);

  onClick() {
    this.#location.back();
  }
}
